import gql from "graphql-tag";

export const USER_FRAGMENT = gql`
  fragment UserFragment on User {
    id
    firstName
    lastName
    email
    emailVerificationTime
    phoneNumberVerificationTime
    phoneNumber
    referrer
    signupInstagramHandle
    connectedInstagramHandle
    instagramToken
    images
    homeCity {
       geonamesId
       name
    }
    iconWorkLocations
    membershipReviewStatus
    skills
    brandTypes
    brandName
    brandDescription
    websiteUrl
    gender
    dateOfBirth
    membership
    instagramTokenRefreshFailedAt
  }
`;

export const LOGIN_USER_FRAGMENT = gql`
  fragment LoginUserFragment on LoginUser {
    token
  }
`;

export const UPDATE_USER_GENERAL_INFORMATION = gql`
  mutation updateUserGeneralInformation($input: UserGeneralInformationInput, $turnstileToken: String) {
    updateUserGeneralInformation(input: $input, turnstileToken: $turnstileToken) {
      ...UserFragment
      auth {
        token
      }      
    }
  }
  ${USER_FRAGMENT}
`;

export const WEB_LOGIN = gql`
  mutation webLogin($email: String, $phoneNumber: String, $turnstileToken: String) {
    webLogin(email: $email, phoneNumber: $phoneNumber, turnstileToken: $turnstileToken) {
      ...LoginUserFragment
      token
    }
  }
  ${LOGIN_USER_FRAGMENT}
`;

export const UPDATE_USER_SKILLS = gql`
  mutation updateUserSkills($input: UserSkillsInput) {
    updateUserSkills(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const UPDATE_USER_ABOUT = gql`
  mutation updateUserAbout($input: UserAboutInput) {
    updateUserAbout(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const UPDATE_USER_BRAND = gql`
  mutation updateUserBrand($input: UserBrandInput) {
    updateUserBrand(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const UPDATE_USER_PHOTOS = gql`
  mutation updateUserPhotos($input: UserPhotosInput) {
    updateUserPhotos(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const SEND_PHONE_NUMBER_VERIFY_CODE = gql`
  mutation sendPhoneNumberVerifyCode($webLoginToken: String, $turnstileToken: String) {
    sendPhoneNumberVerifyCode(webLoginToken: $webLoginToken, turnstileToken: $turnstileToken) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const SEND_EMAIL_VERIFY_CODE = gql`
  mutation sendEmailVerifyCode($webLoginToken: String, $turnstileToken: String)  {
    sendEmailVerifyCode(webLoginToken: $webLoginToken, turnstileToken: $turnstileToken) {
      id
    }
  }
`;

export const CHECK_PHONE_NUMBER_VERIFY_CODE = gql`
  mutation checkPhoneNumberVerifyCode($code: String, $turnstileToken: String) {
    checkPhoneNumberVerifyCode(code: $code, turnstileToken: $turnstileToken) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const CHECK_PHONE_NUMBER_VERIFY_CODE_FOR_WEB_LOGIN = gql`
  mutation checkPhoneNumberVerifyCodeForWebLogin($code: String, $webLoginToken: String, $turnstileToken: String) {
    checkPhoneNumberVerifyCodeForWebLogin(code: $code, webLoginToken: $webLoginToken, turnstileToken: $turnstileToken) {
      ...LoginUserFragment
      token
    }
  }
  ${LOGIN_USER_FRAGMENT}
`;

export const CHECK_EMAIL_VERIFY_CODE = gql`
  mutation checkEmailVerifyCode($code: String, $turnstileToken: String) {
    checkEmailVerifyCode(code: $code, turnstileToken: $turnstileToken) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const CHECK_EMAIL_VERIFY_CODE_FOR_WEB_LOGIN = gql`
  mutation checkEmailVerifyCodeForWebLogin($code: String, $webLoginToken: String, $turnstileToken: String) {
    checkEmailVerifyCodeForWebLogin(code: $code, webLoginToken: $webLoginToken, turnstileToken: $turnstileToken) {
      ...LoginUserFragment
      token
    }
  }
  ${LOGIN_USER_FRAGMENT}
`;

export const GET_CURRENT_USER = gql`
  query getCurrentUser {
    currentUser {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const EXCHANGE_TOKEN = gql`
  mutation exchangeToken($code: String, $redirectUri: String) {
    exchangeToken(code: $code, redirectUri: $redirectUri)
  }
`;

